import { TasksMain } from "components/featured/Tasks/TasksMain";

export const Tasks = () => {
  return (
    <div>
      <TasksMain />
    </div>
  );
};
